import { Injectable } from '@angular/core';

@Injectable()
export class BirthdaysService {
  today;
  constructor() {
      this.today = new Date();
      this.today.setHours(0, 0, 0);
  }
    public daysUntil(birthday: Date) {
        console.log(birthday);
        console.log(typeof birthday);
        const bday = new Date(birthday);
        bday.setFullYear(this.today.getFullYear());
        bday.setHours(0, 0, 0);
        if (bday < this.today) {
            bday.setFullYear(bday.getFullYear() + 1);
        }
        const dateDiff = bday.getTime() - this.today.getTime();
        const daysDiff = Math.round(dateDiff / 1000 / 3600 / 24);
        return daysDiff;
    }
}



// WEBPACK FOOTER //
// ./src/app/birthdays/birthdays.service.ts